import axiosInstance from '@/services/axiosInstance'

async function activarportalzoho () {
  const req = {
    url: 'api/usuarios/activarportalzoho',
    method: 'POST',
    headers: {
      'Content-type': 'application/json',
      'access-control-allow-origin': '*'
    },
  }
  const res = await axiosInstance(req)
  return res.data
}

export { activarportalzoho }
